import React, { useEffect, useState } from 'react';
import { entradaBodegaPreview, generarEntradaBodega, getProductos } from '../services/api';

// Envía los productos de una factura recibida a una bodega (entrada de inventario).
// Por cada línea: mapear a un producto del catálogo (sugerido o buscado) o crearlo al vuelo.
export default function EntradaBodegaModal({ factura, onClose, onFlash }) {
  const [data, setData] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [almacenId, setAlmacenId] = useState('');
  const [rows, setRows] = useState([]);
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState('');

  useEffect(() => {
    entradaBodegaPreview(factura.id).then(({ data }) => {
      setData(data);
      const prin = data.almacenes.find(a => a.es_principal) || data.almacenes[0];
      setAlmacenId(prin ? prin.id : '');
      setRows(data.lineas.map(l => ({
        ...l,
        incluir: !l.es_servicio && !l.ya_ingresado,
        modo: l.sugerido ? 'existente' : 'nuevo',
        producto: l.sugerido || null,
        buscar: '', opciones: [],
        nuevo: { codigo: '', nombre: l.descripcion || '', unidad: l.unidad || 'und', iva_pct: l.iva_pct || 0 },
        cantidad: l.cantidad || 1, costo_unitario: l.costo_unitario || 0,
      })));
      setCargando(false);
    }).catch(e => { setErr(e.response?.data?.error || 'No se pudo cargar la factura'); setCargando(false); });
  }, [factura.id]);

  const upd = (i, patch) => setRows(rs => rs.map((r, j) => j === i ? { ...r, ...patch } : r));

  const buscar = async (i, q) => {
    upd(i, { buscar: q, producto: null });
    if (!q || q.trim().length < 2) return upd(i, { opciones: [] });
    try { const { data } = await getProductos(q.trim()); upd(i, { opciones: (data || []).slice(0, 8) }); }
    catch (_) { upd(i, { opciones: [] }); }
  };

  const incluibles = rows.filter(r => r.incluir && !r.ya_ingresado);
  const guardar = async () => {
    setErr('');
    if (!almacenId) return setErr('Selecciona la bodega destino');
    const lineas = [];
    for (const r of incluibles) {
      const base = { item_id: r.item_id, cantidad: Number(r.cantidad) || 0, costo_unitario: Number(r.costo_unitario) || 0 };
      if (!base.cantidad) continue;
      if (r.modo === 'existente') { if (!r.producto) continue; lineas.push({ ...base, producto_id: r.producto.id }); }
      else { if (!r.nuevo.nombre.trim()) continue; lineas.push({ ...base, nuevo: r.nuevo }); }
    }
    if (!lineas.length) return setErr('No hay líneas listas: elige un producto (o créalo) y una cantidad.');
    setSaving(true);
    try {
      const { data } = await generarEntradaBodega(factura.id, { almacen_id: almacenId, lineas });
      let msg = `✅ ${data.creados} producto(s) ingresado(s) a la bodega`;
      if (data.alertas > 0) msg += ` · ⚠ ${data.alertas} subió(eron) de precio — revisa Alertas de precio`;
      if (onFlash) onFlash(true, msg);
      onClose();
    } catch (e) { setErr(e.response?.data?.error || 'No se pudo generar la entrada'); setSaving(false); }
  };

  const fuenteLbl = { ya: 'ya ingresado antes', memoria: 'aprendido de este proveedor', catalogo: 'coincidencia en catálogo' };

  return (
    <div style={s.overlay} onClick={onClose}>
      <div style={{ ...s.modal, width: 920 }} onClick={e => e.stopPropagation()}>
        <h3 style={s.modalTitle}>Enviar a bodega · {factura.emisor_nombre} {factura.numero}</h3>

        {cargando && <div style={{ color: '#94a3b8', padding: 20 }}>Cargando factura…</div>}
        {!cargando && data && <>
          {data.almacenes.length === 0
            ? <div style={s.warn}>No tienes bodegas activas. Crea una en Inventario → Almacenes antes de ingresar productos.</div>
            : <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12, flexWrap: 'wrap' }}>
                <label style={{ ...s.lbl, margin: 0 }}>Bodega destino:</label>
                <select style={{ ...s.in, width: 'auto', minWidth: 220 }} value={almacenId} onChange={e => setAlmacenId(e.target.value)}>
                  {data.almacenes.map(a => <option key={a.id} value={a.id}>{a.nombre}{a.es_principal ? ' (principal)' : ''}</option>)}
                </select>
                <span style={{ color: '#64748b', fontSize: 12, marginLeft: 'auto' }}>Las cantidades y costos vienen de la factura; puedes ajustarlos.</span>
              </div>}

          <div style={{ ...s.card, maxHeight: '58vh', overflowY: 'auto' }}>
            <table style={s.table}>
              <thead><tr>{['', 'Línea de la factura', 'Producto en tu catálogo', 'Cant.', 'Costo unit.'].map((h, k) => <th key={k} style={s.th}>{h}</th>)}</tr></thead>
              <tbody>
                {rows.map((r, i) => (
                  <tr key={r.item_id} style={{ opacity: r.incluir && !r.ya_ingresado ? 1 : 0.5 }}>
                    <td style={s.td}>
                      <input type="checkbox" checked={r.incluir && !r.ya_ingresado} disabled={r.ya_ingresado}
                        onChange={e => upd(i, { incluir: e.target.checked })} />
                    </td>
                    <td style={{ ...s.td, maxWidth: 240 }}>
                      <div style={{ color: '#e2e8f0' }}>{r.descripcion || <span style={{ color: '#64748b' }}>(sin descripción)</span>}</div>
                      <div style={{ fontSize: 11, color: '#64748b' }}>
                        {r.unidad} · {r.es_servicio ? 'servicio' : 'bien'}
                        {r.ya_ingresado && <span style={{ color: '#fbbf24' }}> · ya ingresado</span>}
                      </div>
                    </td>
                    <td style={{ ...s.td, minWidth: 320 }}>
                      {r.ya_ingresado ? <span style={{ color: '#64748b' }}>—</span> : <>
                        <div style={{ display: 'flex', gap: 6, marginBottom: 6 }}>
                          <button type="button" style={r.modo === 'existente' ? s.tabOn : s.tabOff} onClick={() => upd(i, { modo: 'existente' })}>Existente</button>
                          <button type="button" style={r.modo === 'nuevo' ? s.tabOn : s.tabOff} onClick={() => upd(i, { modo: 'nuevo' })}>Crear nuevo</button>
                        </div>
                        {r.modo === 'existente' ? (
                          r.producto
                            ? <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <span style={{ color: '#6ee7b7', fontSize: 13 }}>✓ {r.producto.codigo ? r.producto.codigo + ' · ' : ''}{r.producto.nombre}</span>
                                {r.sugerido && r.sugerido.id === r.producto.id && <span style={{ fontSize: 10, color: '#64748b' }}>({fuenteLbl[r.sugerido.fuente] || 'sugerido'})</span>}
                                <button type="button" style={s.link} onClick={() => upd(i, { producto: null, buscar: '', opciones: [] })}>cambiar</button>
                              </div>
                            : <div style={{ position: 'relative' }}>
                                <input style={s.in} placeholder="Buscar producto por nombre o código…" value={r.buscar} onChange={e => buscar(i, e.target.value)} />
                                {r.opciones.length > 0 && <div style={s.drop}>
                                  {r.opciones.map(o => <div key={o.id} style={s.dropItem} onClick={() => upd(i, { producto: o, opciones: [], buscar: '' })}>
                                    {o.codigo ? <b>{o.codigo}</b> : ''} {o.nombre}
                                  </div>)}
                                </div>}
                              </div>
                        ) : (
                          <div style={{ display: 'grid', gridTemplateColumns: '90px 1fr 70px', gap: 6 }}>
                            <input style={s.in} placeholder="Código" value={r.nuevo.codigo} onChange={e => upd(i, { nuevo: { ...r.nuevo, codigo: e.target.value } })} />
                            <input style={s.in} placeholder="Nombre del producto" value={r.nuevo.nombre} onChange={e => upd(i, { nuevo: { ...r.nuevo, nombre: e.target.value } })} />
                            <input style={s.in} placeholder="Und" value={r.nuevo.unidad} onChange={e => upd(i, { nuevo: { ...r.nuevo, unidad: e.target.value } })} />
                          </div>
                        )}
                      </>}
                    </td>
                    <td style={s.td}><input type="number" step="0.001" style={{ ...s.in, width: 80 }} value={r.cantidad} disabled={r.ya_ingresado} onChange={e => upd(i, { cantidad: e.target.value })} /></td>
                    <td style={s.td}><input type="number" step="0.01" style={{ ...s.in, width: 110 }} value={r.costo_unitario} disabled={r.ya_ingresado} onChange={e => upd(i, { costo_unitario: e.target.value })} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>}

        {err && <div style={{ color: '#fca5a5', fontSize: 13, marginTop: 10 }}>{err}</div>}
        <div style={s.modalBtns}>
          <button style={s.btnGhost} onClick={onClose}>Cerrar</button>
          {!cargando && data && data.almacenes.length > 0 &&
            <button style={s.btn} disabled={saving || incluibles.length === 0} onClick={guardar}>
              {saving ? 'Ingresando…' : `Ingresar ${incluibles.length} producto(s) a la bodega`}
            </button>}
        </div>
      </div>
    </div>
  );
}

const s = {
  btn: { background: '#1d4ed8', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 18px', fontSize: 14, fontWeight: 600, cursor: 'pointer' },
  btnGhost: { background: 'transparent', color: '#94a3b8', border: '1px solid #334155', borderRadius: 8, padding: '10px 18px', fontSize: 14, cursor: 'pointer' },
  card: { background: '#1e293b', border: '1px solid #334155', borderRadius: 12, overflow: 'visible' },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 13 },
  th: { textAlign: 'left', padding: '8px 10px', color: '#64748b', fontSize: 11, textTransform: 'uppercase', letterSpacing: .5, borderBottom: '1px solid #334155', background: '#0f172a', position: 'sticky', top: 0 },
  td: { padding: '8px 10px', color: '#94a3b8', borderBottom: '1px solid #16202e', verticalAlign: 'top' },
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50, padding: 16 },
  modal: { background: '#1e293b', border: '1px solid #334155', borderRadius: 12, padding: 18, maxWidth: '96vw', maxHeight: '92vh', overflowY: 'auto', color: '#cbd5e1' },
  modalTitle: { color: '#f1f5f9', fontSize: 17, fontWeight: 700, margin: '0 0 12px' },
  modalBtns: { display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 14 },
  lbl: { display: 'block', color: '#94a3b8', fontSize: 12, marginBottom: 5 },
  in: { width: '100%', boxSizing: 'border-box', background: '#0f172a', border: '1px solid #334155', borderRadius: 8, padding: '7px 10px', color: '#f1f5f9', fontSize: 13 },
  link: { background: 'none', border: 'none', color: '#60a5fa', cursor: 'pointer', fontSize: 12, padding: 0 },
  warn: { background: '#3a2c10', color: '#e0a343', fontSize: 13, padding: '10px 14px', borderRadius: 8, marginBottom: 12 },
  tabOn: { background: '#1d4ed8', color: '#fff', border: 'none', borderRadius: 6, padding: '4px 10px', fontSize: 12, cursor: 'pointer' },
  tabOff: { background: '#0f172a', color: '#94a3b8', border: '1px solid #334155', borderRadius: 6, padding: '4px 10px', fontSize: 12, cursor: 'pointer' },
  drop: { position: 'absolute', zIndex: 5, left: 0, right: 0, top: '100%', background: '#0b1220', border: '1px solid #334155', borderRadius: 8, marginTop: 2, maxHeight: 200, overflowY: 'auto' },
  dropItem: { padding: '7px 10px', fontSize: 13, color: '#cbd5e1', cursor: 'pointer', borderBottom: '1px solid #16202e' },
};
